import mapStyles from './mapStyles';

const GoogleMaps = () => {

    let init = ( item ) => {

        let container = item,
            position = {
                lat: parseFloat(item.dataset.lat),
                lng: parseFloat(item.dataset.lng),
            },
            zoom = Math.floor(item.dataset.zoom),
            icon = {
                path: "M-20,0a20,20 0 1,0 40,0a20,20 0 1,0 -40,0",
                fillColor: '#FF0000',
                fillOpacity: 0.6,
                anchor: new google.maps.Point(0,0),
                strokeWeight: 0,
                scale: 0.8
            };

        let map = new google.maps.Map(container, {
            center: position,
            zoom: zoom,
            styles: mapStyles,
        });

        let marker = new google.maps.Marker({
            position: position,
            map: map,
            icon: icon,
        });


    }

    window.initStandardMap = () => {
        let mapContainer = document.getElementById('map-container');
        if (mapContainer) {
            init(mapContainer);
        }
        return;
    }


}

export default GoogleMaps;


// WEBPACK FOOTER //
// ./src/js/initGoogleMaps.js